export const AVAILABLE_LANGUAGES: string[] = [ 'sk', 'en' ];
export const DEFAULT_LANGUAGE = 'sk' as const;

export type SupportedLanguage = 'sk' | 'en';
